import { render, staticRenderFns } from "./Rooms.vue?vue&type=template&id=fd85a444&scoped=true"
import script from "./Rooms.vue?vue&type=script&lang=ts"
export * from "./Rooms.vue?vue&type=script&lang=ts"
import style0 from "./Rooms.vue?vue&type=style&index=0&id=fd85a444&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd85a444",
  null
  
)

export default component.exports